export default __webpack_public_path__ + "static/media/phantom.51acd8cf.png";